import React from 'react';
import { Button } from '@mui/material';

const UnhitDetails = ({ unhit, onBack }) => {
  return (
    <div className="mt-3">
      <h5 className="mb-4">Unhit Details: {unhit.name}</h5>
      <div className="card p-3">
        <div className="mb-3">
          <strong>Name:</strong> {unhit.name}
        </div>
        <div className="mb-3">
          <strong>Processed Name:</strong> {unhit.processedName}
        </div>
        <div>
          <strong>Variations:</strong>
          <ul className="mt-2">
            {unhit.variations &&
              unhit.variations.map((variation, index) => (
                <li key={index}>{variation}</li>
              ))}
          </ul>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button className="btn createButton" onClick={onBack}>
          Back
        </button>
      </div>
    </div>
  );
};

export default UnhitDetails;
